import React from 'react';
import styled from 'styled-components';

import { Option, Select } from 'src/components/core';
import useTranslation from 'src/hooks/use-translation';

type QuantitySelectProps = {
  onQuantityChange: (event: React.ChangeEvent<HTMLSelectElement>) => void;
  quantity: number;
  quantitiesAvailableForSelection: number[];
  prefix?: string;
  children?: React.ReactNode;
};

const quantityMenuProps = {
  PaperProps: { style: { width: 70, marginTop: 2 } },
  disableAutoFocusItem: true,
  autoFocus: false,
  disableAutoFocus: true,
  disableEnforceFocus: true,
};

export function QuantitySelect({
  onQuantityChange,
  quantity,
  quantitiesAvailableForSelection,
  prefix,
  children,
}: QuantitySelectProps): JSX.Element {
  const { t } = useTranslation();

  return (
    <StyledSelect
      SelectDisplayProps={{
        'aria-label': t('common.quantity', 'Quantity'),
        'data-testid': `quantity-select`,
      }}
      onChange={onQuantityChange}
      value={quantity}
      MenuProps={quantityMenuProps}
      $hasPrefix={!!prefix}
      renderValue={(value: number) => (prefix ? <PrefixedValue>{`${prefix} ${value}`}</PrefixedValue> : value)}
    >
      {quantitiesAvailableForSelection.map((num) => (
        <NarrowOption key={num} value={num} data-testid='quantity-select-option'>
          <OptionText>{num}</OptionText>
        </NarrowOption>
      ))}

      {children}
    </StyledSelect>
  );
}

export const NarrowOption = styled(Option)`
  height: 35px;
  min-height: 0;
  padding-left: 23px;
`;

const StyledSelect = styled(Select)<{ $hasPrefix?: boolean }>`
  border-radius: var(--dct--customized-radius-buttons) !important;
  height: 32px;
  width: ${({ $hasPrefix }) => ($hasPrefix ? 'auto' : '55px')};

  .MuiSelect-root {
    left: -7px;
    position: relative;
  }

  > svg {
    width: 10px;
  }
`;

const PrefixedValue = styled.div`
  font-weight: 600;
`;

const OptionText = styled.div`
  max-width: 50px;
  overflow: hidden;
  text-overflow: ellipsis;
`;
